import { User } from "../../types/admin/UserTypes";
import { isPatientSession } from "../userPrefs/validatePermissions";

/**
 * A copy of a self-profile payload with the primary-name keys removed, so they
 * are omitted from the request rather than merely disabled in the form.
 */
export const withoutPrimaryName = <T extends Partial<Pick<User, "first_name" | "last_name">>>(
	payload: T
): Omit<T, "first_name" | "last_name"> => {
	const { first_name, last_name, ...rest } = payload;
	void first_name;
	void last_name;
	return rest;
};

// The one request-boundary name policy for /profile and /customer/profile: the clinic owns a patient-audience session's primary name.
export const toSelfProfilePayload = (userData: User): User =>
	isPatientSession() ? (withoutPrimaryName(userData) as User) : userData;
